import {useContext} from "react"
import Objects from "library-js/utils/Objects";
import contexts from "./contexts";

export default Objects.map(
	contexts,
	(key, context) =>
		() => useContext(context)
);
